import { NgxPermissionsModule } from 'ngx-permissions'
import { RouterModule } from '@angular/router'
import { PaymentCardComponent } from './payment-card.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { TableModule } from '@components/table/table.module'
import { SharedModule } from '@shared/shared.module'
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'

@NgModule({
  declarations: [PaymentCardComponent],
  imports: [
    SweetAlert2Module.forRoot(),
    CommonModule,
    BrowserAnimationsModule,
    TranslateModule,
    ContentEditableModule,
    TableModule,
    SharedModule,
  ],
  exports: [PaymentCardComponent],
})
export class PaymentCardModule {}
